import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
import { scrollToOffer } from '../utils/scroll';
export function GuaranteeSection() {
  return <section className="py-16 md:py-24 bg-gray-50 px-4" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden relative" data-id="element-75">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-100 rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-76"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-red-100 rounded-full blur-3xl opacity-50 translate-y-1/2 -translate-x-1/2" data-id="element-77"></div>

          <div className="flex flex-col md:flex-row relative z-10" data-id="element-78">
            {/* Left side - Seal */}
            <div className="md:w-1/3 p-8 flex items-center justify-center bg-gradient-to-br from-stone-50 to-gray-100 border-b md:border-b-0 md:border-r border-gray-200" data-id="element-79">
              <div className="relative w-48 h-48 flex items-center justify-center" data-id="element-80">
                <div className="absolute inset-0 border-4 border-dashed border-amber-400 rounded-full animate-[spin_20s_linear_infinite]" data-id="element-81"></div>
                <div className="absolute inset-2 bg-gradient-to-br from-amber-300 to-amber-500 rounded-full shadow-inner flex flex-col items-center justify-center text-white p-4 text-center" data-id="element-82">
                  <ShieldCheckIcon className="w-12 h-12 mb-2" data-id="element-83" />
                  <span className="font-black text-lg leading-tight" data-id="element-84">
                    45 GIORNI
                    <br data-id="element-85" />
                    GARANZIA
                  </span>
                </div>
              </div>
            </div>

            {/* Right side - Content */}
            <div className="md:w-2/3 p-8 md:p-12 flex flex-col justify-center" data-id="element-86">
              <h2 className="text-3xl font-bold text-stone-900 mb-4" data-id="element-87">
                Garanzia di Soddisfazione 100%
              </h2>
              <p className="text-lg text-stone-600 mb-6" data-id="element-88">
                Prova il Metodo Completo per Insegnanti di Tango in totale
                tranquillità. Hai 45 giorni di garanzia per valutare il
                materiale senza alcun rischio.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8" data-id="element-89">
                <div className="flex items-center space-x-2" data-id="element-90">
                  <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-91" />
                  <span className="text-stone-700 font-medium" data-id="element-92">
                    Nessun rischio per te
                  </span>
                </div>
                <div className="flex items-center space-x-2" data-id="element-93">
                  <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-94" />
                  <span className="text-stone-700 font-medium" data-id="element-95">
                    Rimborso completo del 100%
                  </span>
                </div>
                <div className="flex items-center space-x-2" data-id="element-96">
                  <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-97" />
                  <span className="text-stone-700 font-medium" data-id="element-98">
                    Senza fare domande
                  </span>
                </div>
                <div className="flex items-center space-x-2" data-id="element-99">
                  <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-100" />
                  <span className="text-stone-700 font-medium" data-id="element-101">
                    Procedura semplice via email
                  </span>
                </div>
              </div>

              <button onClick={scrollToOffer} className="bg-stone-900 hover:bg-stone-800 text-white font-bold py-4 px-8 rounded-xl shadow-lg transition-colors w-full sm:w-auto self-start" data-id="element-102">
                🔵 Prova senza rischi
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}